export default {
  navigation: {
    key: 'navigation',
    label: 'Navigation',
    description: 'Icons used to signify a change of route or location',
  },
  users: {
    key: 'users',
    label: 'Users',
    description: '',
  },
  news: {
    key: 'news',
    label: 'News',
    description: 'Icons used to signify all things related to news',
  },
  messages: {
    key: 'messages',
    label: 'Messages',
    description: 'Icons used to signify all things related to messaging',
  },
  forms: {
    key: 'forms',
    label: 'Forms',
    description: 'Icons used to signify all things related to forms',
  },
  calendar: {
    key: 'calendar',
    label: 'Calendar',
    description: 'Icons used to signify all things related to time and date',
  },
  actions: {
    key: 'actions',
    label: 'Actions',
    description: 'Icons used to signify actions',
  },
  alerts: {
    key: 'alerts',
    label: 'Alerts',
    description: 'Icons used to signify actions',
  },
  other: {
    key: 'other',
    label: 'Other',
    description: 'Any uncategorized icon',
  },
}
